<template>
  <div class="awardContainer" :style="bgStyle"></div>
</template>

<script>
export default {
  props: {
    awardData: {
      type: Object,
      required: true
    }
  },
  computed: {
    bgStyle() {
      return {
        background: `center / cover no-repeat url("${this.awardData.imgUrl}")`
      };
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
}
</style>
